/*!
 * ihavecookies - jQuery plugin for displaying cookie/privacy message
 * v0.3.2
 *
 * Copyright (c) 2018 Ketan Mistry (https://iamketan.com.au)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Modified and Extended for use by MCode - Darren Bramley
 *
 */
(function ($) {

    /*
    |--------------------------------------------------------------------------
    | Cookie Message
    |--------------------------------------------------------------------------
    |
    | Displays the cookie message on first visit or 30 days after their
    | last visit.
    |
    | @param event - 'reinit' to reopen the cookie message
    |
    */
    var dropCookie;
    var setButtonState;
    var hidePopup;
    $.fn.ihavecookies = function (options, event) {

        var $element = $(this);

        // ### Set defaults ### - Can be overridden on page
        var settings = $.extend({
            cookieTypes: [
                {
                    type: 'Advertising',
                    value: 'advertising',
                    description:
                        "These cookies remember the products you are interested in to show you other products or offers that might be relevant when you visit other websites. They are also used to make sure we don't show you adverts for things you've already bought and find out if our marketing was successful. Advertising cookies collect and save information about which pages you look at, what you click on, and if you buy a product. If you choose not to accept, you will still see adverts as you browse the web, but they won't be as relevant to your personal interests. The website will still work as normal."
                },
                {
                    type: 'Analytics',
                    value: 'analytics',
                    description:
                        "These cookies are used to find out how people are using our site. This helps us fix areas that may not be working and make the site easier to navigate. They're also used to check whether changes we make to the website make it better or worse for you."
                }
            ],
            brandForLogo:
                'Your Logo Here', //Colour and Background Colour are changed in the css file search for 'BrandForLogo'
            title: 'Cookies on this website',
            message:
                "<p>In order to make our site work and keep your information safe, we use strictly necessary cookies. We would also like to set certain optional analytics and marketing cookies on your device to help us understand how you use our site and to personalise your experience.</p>" +
                "<p>You can agree to these optional cookies by pressing the 'accept all' button below. If you want to learn more, or update your cookie preferences, just click the 'manage' button below.</p>",
            link: '/privacy-policy',
            delay: 2000,
            expires: 30,
            moreInfoLabel: 'View Cookie Policy',
            acceptBtnLabel: 'Accept All',
            advancedBtnLabel: 'Manage',
            necessaryBtnLabel: 'Accept Only Necessary Cookies',
            saveAndContinueBtnLabel: 'Save Preferences and Continue',
            cookieTypesTitle: 'Select cookies to accept',
            fixedCookieTypeLabel: 'Strictly Necessary',
            fixedCookieTypeDesc:
                "These cookies are essential for the website to function and also protect our site from potential cyber attacks and fraudulent activity.",
            onAccept: function () {
                $('body').removeClass('parentDisable');

                var myPreferences = $.fn.ihavecookies.cookie();
                //console.log('Yay! The following preferences were saved...');
                console.log(myPreferences);
            },
            uncheckBoxes: false
        },
            options);

        var myCookie = getCookie('cookieControl');
        var myCookiePrefs = getCookie('cookieControlPrefs');

        //  ##########   Code to trigger display of message   ###########

        if (!myCookie || !myCookiePrefs || event == 'reinit') {
            // Remove all instances of the cookie message so it's not duplicated
            $('#gdpr-cookie-message').remove();
            $('#cookie-container').remove();


            // Set the 'necessary' cookie type checkbox which can not be unchecked
            var cookieTypes =
                '<li><input type="checkbox" name="gdpr[]" value="necessary" checked="checked" disabled="disabled"> <label title="' +
                settings.fixedCookieTypeDesc +
                '">' +
                settings.fixedCookieTypeLabel +
                '</label>' +
                '<p style="font-size:small;">' +
                settings.fixedCookieTypeDesc +
                '</p>' +
                '</li>';

            $('body').addClass('parentDisable');
            //$('#cookie-container').removeClass('cookie-container');

            // Generate list of cookie type checkboxes
            preferences = JSON.parse(myCookiePrefs);

            $.each(settings.cookieTypes,
                function (index, field) {
                    if (field.type !== '' && field.value !== '') {
                        var cookieTypeDescription = '';
                        if (field.description !== false) {
                            cookieTypeDescription = ' title="' + field.description + '"';
                        }
                        cookieTypes += '<li>' +
                            '<input class="cookie-selectable-checkbox" type="checkbox" id="gdpr-cookietype-' +
                            field.value +
                            '" name="gdpr[]" value="' +
                            field.value +
                            '" data-auto="on"> ' +
                            '<label for="gdpr-cookietype-' +
                            field.value +
                            '"' +
                            cookieTypeDescription +
                            '>' +
                            field.type +
                            '</label>' +
                            '<div id="click-for-info-' +
                            field.value +
                            '" title="Click for Info" class="cookie-type-collapsible">+</div>' +
                            '<div id="cookie-type-desc-' +
                            field.value +
                            '" style="font-size:small;display:none;">' +
                            field.description +
                            '<div style="text-align:right;"><a href="/partners?brand=' +
                            encodeURI(settings.brandForLogo) +
                            '" title="View Partners we work with in new browser tab" target="_blank">Partners we work with</a></div>' +
                            '</div>' +
                            '</li>';
                    }
                });

            // Display initial cookie message on page
            var cookieMessageStart =
                '<div id="cookie-container" class="cookie-container">' +
                '<div id="gdpr-cookie-message">' +
                '<dialog id="gdpr-cookie-dialog">' +
                '<div class="brand-for-logo">' +
                settings.brandForLogo +
                '</div>' +
                '<h3 id="cookieTitle" tabindex="1" aria-label="' + settings.title + '">' +
                settings.title +
                '</h3>' +
                '<p>' +
                settings.message +
                ' <a href="' +
                settings.link +
                '" target="_blank" title="Open Cookie Policy in new browser tab">' +
                settings.moreInfoLabel +
                '</a>' +
                '</p>' +
                '<div id="gdpr-cookie-types" style="display:none;">' +
                '<h5>' +
                settings.cookieTypesTitle +
                '</h5>' +
                '<ul>' +
                cookieTypes +
                '</ul>' +
                '</div>' +
                '<div id="cookie-container-button-row">' +
                '<button id="gdpr-cookie-necessary" style="display:none;" type="button">' +
                settings.necessaryBtnLabel.toUpperCase() +
                '</button>' +
                '<button id="gdpr-cookie-advanced" style="display:block;" type="button">' +
                settings.advancedBtnLabel.toUpperCase() +
                '</button>' +
                '<button id="gdpr-cookie-accept" style="display:block;"type="button">' +
                settings.acceptBtnLabel.toUpperCase() +
                '</button>' +
                '<button id="gdpr-cookie-save-preferences" style="display:none;"type="button">' +
                settings.saveAndContinueBtnLabel.toUpperCase() +
                '</button>' +
                '</div>' +
                '</dialog>' +
                '</div>' +
                '</div>';

            var cookieMessage = cookieMessageStart;

            // #########################################
            // ###########     Show Popup  #############
            // #########################################
            setTimeout(function () {
                $($element).append(cookieMessage);
                $('#gdpr-cookie-message').hide().fadeIn('slow',
                    function () {
                        // If reinit'ing, open the advanced section of message
                        // and re-check all previously selected options.
                        //document.getElementById("gdpr-cookie-dialog").showModal();
                        document.getElementById("gdpr-cookie-dialog").style.display = "block";

                        if (event == 'reinit') {
                            $('#gdpr-cookie-advanced').trigger('click');
                            $.each(preferences,
                                function (index, field) {
                                    $('input#gdpr-cookietype-' + field).prop('checked', true);
                                });
                            setButtonState();
                        }
                    });
            },
                settings.delay);

            // ACCEPT ALL BUTTON
            // When accept button is clicked drop cookie
            $('body').on('click',
                '#gdpr-cookie-accept',
                function () {
                    dropCookie(true, settings.expires);

                    //Accepted all, make sure they are checked
                    $('input[name="gdpr[]"').prop('checked', true);

                    // Save users cookie preferences (in a cookie!)
                    var prefs = [];
                    $.each($('input[name="gdpr[]"]').serializeArray(),
                        function (i, field) {
                            prefs.push(field.value);
                        });
                    setCookie('cookieControlPrefs', encodeURIComponent(JSON.stringify(prefs)), settings.expires);

                    // Run callback function
                    settings.onAccept.call(this);

                    hidePopup();
                });

            // MANAGE BUTTON
            // Toggle advanced cookie selection options
            $('body').on('click',
                '#gdpr-cookie-advanced',
                function () {
                    // Uncheck all checkboxes except for the disabled 'necessary'
                    // one and set 'data-auto' to OFF for all. The user can now
                    // select the cookies they want to accept.
                    $('input[name="gdpr[]"]:not(:disabled)').attr('data-auto', 'off').prop('checked', false);
                    $('#gdpr-cookie-types').slideDown('fast',
                        function () {
                            $('#gdpr-cookie-advanced').prop('disabled', true);
                            $('#gdpr-cookie-advanced').hide();
                            $('#gdpr-cookie-necessary').show();
                        });
                });

            // ACCEPT ONLY NECESSARY COOKIES BUTTON
            // Disable Advertising and Analytics
            $('body').on('click',
                '#gdpr-cookie-necessary',
                function () {
                    console.log('Clicked gdpr-cookie-necessary');

                    hidePopup();

                    dropCookie(true, settings.expires);

                    // Uncheck all options as only necessary has been clicked
                    $('input[name="gdpr[]"][data-auto="off"]').prop('checked', false);

                    // Save users cookie preferences (in a cookie!)
                    var prefs = [];
                    $.each($('input[name="gdpr[]"]').serializeArray(),
                        function (i, field) {
                            prefs.push(field.value);
                        });
                    setCookie('cookieControlPrefs', encodeURIComponent(JSON.stringify(prefs)), settings.expires);

                    var myPreferences = $.fn.ihavecookies.cookie();
                    console.log(myPreferences);
                });

            // BUTTON TOGGLE ON MANAGE SCREEN
            // If it's a custom selection, switch button to 'Save and Continue' if not 'Accept All'
            $('body').on('click',
                '.cookie-selectable-checkbox',
                function () {
                    setButtonState();
                }
            );

            // SAVE AND CONTINUE BUTTON
            //CUSTOM Options - Customer has hit MANAGE, then selected custom options
            $('body').on('click',
                '#gdpr-cookie-save-preferences',
                function () {

                    $(hidePopup());

                    dropCookie(true, settings.expires);

                    // Save users cookie preferences (in a cookie!)
                    var prefs = [];
                    $.each($('input[name="gdpr[]"]').serializeArray(),
                        function (i, field) {
                            prefs.push(field.value);
                        });
                    setCookie('cookieControlPrefs', encodeURIComponent(JSON.stringify(prefs)), settings.expires);

                    var myPreferences = $.fn.ihavecookies.cookie();
                    console.log(myPreferences);
                });
        } else {
            var cookieVal = true;
            if (myCookie == 'false') {
                cookieVal = false;
            }
            dropCookie(cookieVal, settings.expires);
        }

        // Uncheck any checkboxes on page load
        if (settings.uncheckBoxes === true) {
            $('input[type="checkbox"].ihavecookies').prop('checked', false);
        }

    };

    // Method to get cookie value
    $.fn.ihavecookies.cookie = function () {
        var preferences = getCookie('cookieControlPrefs');
        return JSON.parse(preferences);
    };

    // Method to check if user cookie preference exists
    $.fn.ihavecookies.preference = function (cookieTypeValue) {
        var control = getCookie('cookieControl');
        var preferences = getCookie('cookieControlPrefs');
        preferences = JSON.parse(preferences);
        if (control === false) {
            return false;
        }
        if (preferences === false || preferences.indexOf(cookieTypeValue) === -1) {
            return false;
        }
        return true;
    };

    /*
    |--------------------------------------------------------------------------
    | Drop Cookie
    |--------------------------------------------------------------------------
    |
    | Function to drop the cookie with a boolean value of true.
    |
    */
    dropCookie = function (value, expiryDays) {
        setCookie('cookieControl', value, expiryDays);
        $('#gdpr-cookie-message').fadeOut('fast',
            function () {
                $(this).remove();
            });
    };

    /*
    |--------------------------------------------------------------------------
    | Set Cookie
    |--------------------------------------------------------------------------
    |
    | Sets cookie with 'name' and value of 'value' for 'expiry_days'.
    |
    */
    var setCookie = function (name, value, expiry_days) {
        var d = new Date();
        d.setTime(d.getTime() + (expiry_days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";secure;" + expires + ";path=/";
        document.cookie
        return getCookie(name);
    };

    /*
    |--------------------------------------------------------------------------
    | Get Cookie
    |--------------------------------------------------------------------------
    |
    | Gets cookie called 'name'.
    |
    */
    var getCookie = function (name) {
        var cookie_name = name + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cookie_name) === 0) {
                return c.substring(cookie_name.length, c.length);
            }
        }
        return false;
    };

    /*
    |--------------------------------------------------------------------------
    | Set Button State
    |--------------------------------------------------------------------------
    |
    | If Custom preferences (i.e. only one checkbox selected), switch button to Save Preferences and Continue
    | Else Button = Accept All
    |
    */
    setButtonState = function () {
        {
            var selectedChecks = $('.cookie-selectable-checkbox:checked').length;
            var totalSelectableChecks = $('.cookie-selectable-checkbox').length;
            if (selectedChecks > 0 && selectedChecks < totalSelectableChecks) {
                // console.log('Custom Selection');
                $('#gdpr-cookie-accept').prop('disabled', true);
                $('#gdpr-cookie-accept').hide();
                $('#gdpr-cookie-save-preferences').prop('disabled', false);
                $('#gdpr-cookie-save-preferences').show();
            } else {
                // console.log('Standard Selection');
                $('#gdpr-cookie-save-preferences').prop('disabled', true);
                $('#gdpr-cookie-save-preferences').hide();
                $('#gdpr-cookie-accept').prop('disabled', false);
                $('#gdpr-cookie-accept').show();
            }
        }
    };

    /*
    |--------------------------------------------------------------------------
    | Hide Popup
    |--------------------------------------------------------------------------
    |
    */
    hidePopup = function () {
        $('body').removeClass('parentDisable');
        $('#cookie-container').removeClass('cookie-container');
        //document.getElementById("gdpr-cookie-dialog").close();
        document.getElementById("gdpr-cookie-dialog").style.display = "none";
    };


}(jQuery));

function revokeCookieConsent() {
    $('body').ihavecookies(options, 'reinit');
}

$(document).ready(function () {
    //Toggle Advanced Cookie Description
    $('body').on('click', '[id^=click-for-info-]', function () {
        if (this.innerText === '+') {
            this.innerText = '-';
            this.nextElementSibling.style.display = 'block';
        } else {
            this.innerText = '+';
            this.nextElementSibling.style.display = 'none';
        }
    });
});